export default "__VITE_ASSET__4299bfa0__"